import { constVoid, DOM, IOO, pipe, RR, s, v } from '@packages/prelude'

import 'bootstrap'
import '../css/main.scss'

import { Swiper, Navigation, Pagination, SwiperOptions, Autoplay } from 'swiper'

window.addEventListener(
  'DOMContentLoaded',
  pipe(
    IOO.of({ document }),
    IOO.bind('menu', ({ document }) => pipe(document, DOM.querySelector('#navbar-main'))),
    IOO.bind('toggleBtn', ({ document }) => pipe(document, DOM.querySelector('button.btn-toggle-offcanvas'))),
    IOO.chainFirstIOK(({ menu, toggleBtn }) =>
      pipe(
        menu,
        DOM.addEventListener('hide.bs.offcanvas')(() => () => {
          console.log('hide')
          toggleBtn.classList.add('collapsed')
        })
      )
    ),
    IOO.chainFirstIOK(({ menu, toggleBtn }) =>
      pipe(
        menu,
        DOM.addEventListener('show.bs.offcanvas')(() => () => toggleBtn.classList.remove('collapsed'))
      )
    )
  )
)

const makeSwiper = (selector: string, options: SwiperOptions) =>
  pipe(
    IOO.of({ document }),
    IOO.chain(({ document }) => pipe(document, DOM.querySelector(`#${selector}`)) as IOO.IOOption<HTMLElement>),
    IOO.fold(
      () => constVoid,
      element => IOO.of(new Swiper(element, options))
    )
  )()

const getSwipersOptions = (): Record<string, SwiperOptions> => ({
  headerSlider: {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    speed: 750,
    modules: [Navigation, Pagination, Autoplay],
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets'
    },
    autoplay: {
      delay: 10000
    }
  }
})

pipe(
  document,
  getSwipersOptions,
  RR.foldMapWithIndex(s.Ord)(v.Monoid)((selector, options) => makeSwiper(selector, options))
)
